"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultFormat = void 0;
var ResultFormat;
(function (ResultFormat) {
    ResultFormat["csv"] = "csv";
    ResultFormat["json"] = "json";
})(ResultFormat = exports.ResultFormat || (exports.ResultFormat = {}));
//# sourceMappingURL=result-format.type.js.map